


import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {MediaQueryService} from '@/services/media-query.service';

@Component({})
export default class AppMapInfoContainer extends Vue {

  public localIsExpanded: boolean = false;
  public mediaQueryService: MediaQueryService = MediaQueryService.getInstance();

  @Prop({default: ''})
  public title!: string;

  @Emit('state-change')
  public emitStateChange(): boolean {
    return this.isExpanded();
  }

  public created(): void {
    this.localIsExpanded = this.mediaQueryService.aboveMd;
    this.mediaQueryService.whenChange.subscribe(() => {
      const beforeState: boolean = this.isExpanded();
      this.localIsExpanded = this.mediaQueryService.aboveMd;
      if (beforeState !== this.isExpanded()) {
        this.emitStateChange();
      }
    });
  }

  public toggleExpandedState(): void {
    this.localIsExpanded = !this.isExpanded();
    this.emitStateChange();
  }

  public expand(): void {
    this.localIsExpanded = true;
    this.emitStateChange();
  }

  public collapse(): void {
    this.localIsExpanded = false;
    this.emitStateChange();
  }

  public isExpanded(): boolean {
    return this.localIsExpanded;
  }

  public width(): number {
    let width: number = 0;
    if (this.mediaQueryService.aboveMd) {
      const leftSidebarRef = this.$refs.leftSidebar as HTMLDivElement;
      width = this.isExpanded() ? leftSidebarRef.getBoundingClientRect().width : 0;
    }
    return width;
  }
}
